export enum ColorEncoding {
  LINEAR = 0,
  SRGB = 1,
}